// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1exDO","card":"Cards_card__3R2Ps","infected":"Cards_infected__38KSP","recovered":"Cards_recovered__373pl","deaths":"Cards_deaths__1RNEz"};